/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateGameDto } from '../models/work-create-game-dto';
import { WorkLeaderboardEntryDto } from '../models/work-leaderboard-entry-dto';
import { WorkModifyGoalDto } from '../models/work-modify-goal-dto';
import { WorkTablesoccerGameDto } from '../models/work-tablesoccer-game-dto';
import { WorkTablesoccerGameEventDtoEvent } from '../models/work-tablesoccer-game-event-dto-event';
import { WorkTablesoccerUserDto } from '../models/work-tablesoccer-user-dto';
import { WorkTeamLeaderboardEntryDto } from '../models/work-team-leaderboard-entry-dto';

@Injectable({ providedIn: 'root' })
export class WorkTablesoccerV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tablesoccerV2ControllerGetRecentGames()` */
  static readonly TablesoccerV2ControllerGetRecentGamesPath = '/v2/tablesoccer/games';

  /**
   * Holt die letzten Spiele.
   *
   * Gibt die letzten N Spiele zurück
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerGetRecentGames()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetRecentGames$Response(
    params?: {

    /**
     * Anzahl der Spiele (default: 10)
     */
      limit?: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTablesoccerGameDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerGetRecentGamesPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTablesoccerGameDto>>;
      })
    );
  }

  /**
   * Holt die letzten Spiele.
   *
   * Gibt die letzten N Spiele zurück
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerGetRecentGames$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetRecentGames(
    params?: {

    /**
     * Anzahl der Spiele (default: 10)
     */
      limit?: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTablesoccerGameDto>> {
    return this.tablesoccerV2ControllerGetRecentGames$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTablesoccerGameDto>>): Array<WorkTablesoccerGameDto> => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerCreateGame()` */
  static readonly TablesoccerV2ControllerCreateGamePath = '/v2/tablesoccer/games';

  /**
   * Startet ein neues Spiel.
   *
   * Erstellt ein neues Spiel zwischen zwei Teams
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerCreateGame()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tablesoccerV2ControllerCreateGame$Response(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkCreateGameDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTablesoccerGameDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerCreateGamePath, 'post');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTablesoccerGameDto>;
      })
    );
  }

  /**
   * Startet ein neues Spiel.
   *
   * Erstellt ein neues Spiel zwischen zwei Teams
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerCreateGame$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tablesoccerV2ControllerCreateGame(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkCreateGameDto
    },
    context?: HttpContext
  ): Observable<WorkTablesoccerGameDto> {
    return this.tablesoccerV2ControllerCreateGame$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTablesoccerGameDto>): WorkTablesoccerGameDto => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerGetCurrentGame()` */
  static readonly TablesoccerV2ControllerGetCurrentGamePath = '/v2/tablesoccer/games/current';

  /**
   * Holt das aktuell laufende Spiel.
   *
   * Gibt das laufende Spiel zurück oder null
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerGetCurrentGame()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetCurrentGame$Response(
    params?: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTablesoccerGameDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerGetCurrentGamePath, 'get');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTablesoccerGameDto>;
      })
    );
  }

  /**
   * Holt das aktuell laufende Spiel.
   *
   * Gibt das laufende Spiel zurück oder null
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerGetCurrentGame$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetCurrentGame(
    params?: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkTablesoccerGameDto> {
    return this.tablesoccerV2ControllerGetCurrentGame$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTablesoccerGameDto>): WorkTablesoccerGameDto => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerGetGame()` */
  static readonly TablesoccerV2ControllerGetGamePath = '/v2/tablesoccer/games/{id}';

  /**
   * Holt ein Spiel.
   *
   * Gibt ein Spiel mit allen Details zurück
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerGetGame()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetGame$Response(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTablesoccerGameDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerGetGamePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTablesoccerGameDto>;
      })
    );
  }

  /**
   * Holt ein Spiel.
   *
   * Gibt ein Spiel mit allen Details zurück
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerGetGame$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetGame(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkTablesoccerGameDto> {
    return this.tablesoccerV2ControllerGetGame$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTablesoccerGameDto>): WorkTablesoccerGameDto => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerDeleteGame()` */
  static readonly TablesoccerV2ControllerDeleteGamePath = '/v2/tablesoccer/games/{id}';

  /**
   * Löscht ein Spiel.
   *
   * Löscht ein Spiel
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerDeleteGame()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerDeleteGame$Response(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTablesoccerGameDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerDeleteGamePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTablesoccerGameDto>;
      })
    );
  }

  /**
   * Löscht ein Spiel.
   *
   * Löscht ein Spiel
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerDeleteGame$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerDeleteGame(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkTablesoccerGameDto> {
    return this.tablesoccerV2ControllerDeleteGame$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTablesoccerGameDto>): WorkTablesoccerGameDto => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerAddGoal()` */
  static readonly TablesoccerV2ControllerAddGoalPath = '/v2/tablesoccer/games/{id}/goals';

  /**
   * Fügt ein Tor hinzu.
   *
   * Fügt ein Tor zu einem laufenden Spiel hinzu
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerAddGoal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tablesoccerV2ControllerAddGoal$Response(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkModifyGoalDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTablesoccerGameDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerAddGoalPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTablesoccerGameDto>;
      })
    );
  }

  /**
   * Fügt ein Tor hinzu.
   *
   * Fügt ein Tor zu einem laufenden Spiel hinzu
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerAddGoal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tablesoccerV2ControllerAddGoal(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkModifyGoalDto
    },
    context?: HttpContext
  ): Observable<WorkTablesoccerGameDto> {
    return this.tablesoccerV2ControllerAddGoal$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTablesoccerGameDto>): WorkTablesoccerGameDto => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerRemoveGoal()` */
  static readonly TablesoccerV2ControllerRemoveGoalPath = '/v2/tablesoccer/games/{id}/goals';

  /**
   * Entfernt ein Tor.
   *
   * Entfernt ein Tor von einem laufenden Spiel
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerRemoveGoal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tablesoccerV2ControllerRemoveGoal$Response(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkModifyGoalDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTablesoccerGameDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerRemoveGoalPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTablesoccerGameDto>;
      })
    );
  }

  /**
   * Entfernt ein Tor.
   *
   * Entfernt ein Tor von einem laufenden Spiel
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerRemoveGoal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tablesoccerV2ControllerRemoveGoal(
    params: {

    /**
     * Spiel ID
     */
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkModifyGoalDto
    },
    context?: HttpContext
  ): Observable<WorkTablesoccerGameDto> {
    return this.tablesoccerV2ControllerRemoveGoal$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTablesoccerGameDto>): WorkTablesoccerGameDto => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerGetUserLeaderboard()` */
  static readonly TablesoccerV2ControllerGetUserLeaderboardPath = '/v2/tablesoccer/leaderboard/users';

  /**
   * Holt die Spieler-Bestenliste.
   *
   * Gibt die Bestenliste aller Spieler zurück
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerGetUserLeaderboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetUserLeaderboard$Response(
    params?: {

    /**
     * Anzahl der Einträge (optional)
     */
      limit?: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkLeaderboardEntryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerGetUserLeaderboardPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkLeaderboardEntryDto>>;
      })
    );
  }

  /**
   * Holt die Spieler-Bestenliste.
   *
   * Gibt die Bestenliste aller Spieler zurück
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerGetUserLeaderboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetUserLeaderboard(
    params?: {

    /**
     * Anzahl der Einträge (optional)
     */
      limit?: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkLeaderboardEntryDto>> {
    return this.tablesoccerV2ControllerGetUserLeaderboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkLeaderboardEntryDto>>): Array<WorkLeaderboardEntryDto> => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerGetTeamLeaderboard()` */
  static readonly TablesoccerV2ControllerGetTeamLeaderboardPath = '/v2/tablesoccer/leaderboard/teams';

  /**
   * Holt die Team-Bestenliste.
   *
   * Gibt die Bestenliste aller Teams zurück
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerGetTeamLeaderboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetTeamLeaderboard$Response(
    params?: {

    /**
     * Anzahl der Einträge (optional)
     */
      limit?: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTeamLeaderboardEntryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerGetTeamLeaderboardPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTeamLeaderboardEntryDto>>;
      })
    );
  }

  /**
   * Holt die Team-Bestenliste.
   *
   * Gibt die Bestenliste aller Teams zurück
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerGetTeamLeaderboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetTeamLeaderboard(
    params?: {

    /**
     * Anzahl der Einträge (optional)
     */
      limit?: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTeamLeaderboardEntryDto>> {
    return this.tablesoccerV2ControllerGetTeamLeaderboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTeamLeaderboardEntryDto>>): Array<WorkTeamLeaderboardEntryDto> => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerGetActivePlayers()` */
  static readonly TablesoccerV2ControllerGetActivePlayersPath = '/v2/tablesoccer/players';

  /**
   * Holt alle aktiven Spieler.
   *
   * Gibt alle aktiven Spieler zurück (nur id, firstName, lastName, userImage)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerGetActivePlayers()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetActivePlayers$Response(
    params?: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTablesoccerUserDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerGetActivePlayersPath, 'get');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTablesoccerUserDto>>;
      })
    );
  }

  /**
   * Holt alle aktiven Spieler.
   *
   * Gibt alle aktiven Spieler zurück (nur id, firstName, lastName, userImage)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerGetActivePlayers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerGetActivePlayers(
    params?: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTablesoccerUserDto>> {
    return this.tablesoccerV2ControllerGetActivePlayers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTablesoccerUserDto>>): Array<WorkTablesoccerUserDto> => r.body)
    );
  }

  /** Path part for operation `tablesoccerV2ControllerListenToGameEvents()` */
  static readonly TablesoccerV2ControllerListenToGameEventsPath = '/v2/tablesoccer/events/{apiKey}';

  /**
   * Server-Sent Events für Spiel-Updates.
   *
   * Streamt Events bei Spielstart, Spielende, Toren und Löschungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tablesoccerV2ControllerListenToGameEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerListenToGameEvents$Response(
    params: {
      apiKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTablesoccerGameEventDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTablesoccerV2Service.TablesoccerV2ControllerListenToGameEventsPath, 'get');
    if (params) {
      rb.path('apiKey', params.apiKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTablesoccerGameEventDtoEvent>;
      })
    );
  }

  /**
   * Server-Sent Events für Spiel-Updates.
   *
   * Streamt Events bei Spielstart, Spielende, Toren und Löschungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tablesoccerV2ControllerListenToGameEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tablesoccerV2ControllerListenToGameEvents(
    params: {
      apiKey: string;
    },
    context?: HttpContext
  ): Observable<WorkTablesoccerGameEventDtoEvent> {
    return this.tablesoccerV2ControllerListenToGameEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTablesoccerGameEventDtoEvent>): WorkTablesoccerGameEventDtoEvent => r.body)
    );
  }

}
